function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "14 14 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0Z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(10 10)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 11.07v2.02H8.039l5.556 5.556-1.435 1.434-8-8 8-8 1.434 1.434-5.555 5.556Z",
    transform: "translate(9.84 9.92)",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgBack;